import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-265e83f6")
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "p-d-flex p-align-center p-mb-4" }
const _hoisted_3 = { class: "p-my-0" }
const _hoisted_4 = { class: "map" }
const _hoisted_5 = {
  id: "w3_map",
  ref: "mapEl",
  class: "p-mt-3"
}
const _hoisted_6 = { class: "p-d-flex p-align-center" }
const _hoisted_7 = ["for"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Ticket #ID: ")
const _hoisted_9 = { class: "p-mb-0 p-ml-2" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Broker Name: ")
const _hoisted_11 = { class: "p-mb-0 p-ml-2" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Driver Name: ")
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "load" }
const _hoisted_15 = {
  key: 0,
  class: "pi pi-arrow-up"
}
const _hoisted_16 = { class: "dump" }
const _hoisted_17 = {
  key: 0,
  class: "pi pi-arrow-down"
}
const _hoisted_18 = { class: "status_buttons" }
const _hoisted_19 = { class: "p-button-label" }
const _hoisted_20 = { class: "time" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableSkeleton = _resolveComponent("TableSkeleton")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Button = _resolveComponent("Button")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.requestPending)
    ? (_openBlock(), _createBlock(_component_TableSkeleton, {
        key: 0,
        columns: 3,
        rows: 5
      }))
    : (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("h5", _hoisted_3, "Selected moment: " + _toDisplayString(_ctx.selectedTime), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, null, 512)
        ]),
        _createVNode(_component_Slider, {
          class: "p-mt-4",
          modelValue: _ctx.sliderIndex,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.sliderIndex = $event)),
          min: 0,
          max: _ctx.maxSlider,
          disabled: !_ctx.maxSlider
        }, null, 8, ["modelValue", "max", "disabled"]),
        _createVNode(_component_Accordion, {
          multiple: true,
          class: "p-mt-4"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ticketsHistory, (ticket) => {
              return (_openBlock(), _createBlock(_component_AccordionTab, {
                key: ticket.id
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "p-d-inline-block",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_Checkbox, {
                        modelValue: ticket.selected,
                        "onUpdate:modelValue": ($event: any) => (ticket.selected = $event),
                        inputId: 'ticket_' + ticket.id,
                        binary: true,
                        onChange: ($event: any) => (_ctx.changeSelectedTickets(ticket))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId", "onChange"]),
                      _createElementVNode("label", {
                        for: 'ticket_' + ticket.id,
                        class: "p-ml-2"
                      }, [
                        _hoisted_8,
                        _createVNode(_component_Badge, {
                          class: "p-d-block",
                          style: _normalizeStyle('background:' + ticket.fillColor),
                          value: ticket.id,
                          severity: "warning"
                        }, null, 8, ["style", "value"])
                      ], 8, _hoisted_7),
                      _createElementVNode("p", _hoisted_9, [
                        _hoisted_10,
                        _createVNode(_component_Badge, {
                          class: "p-d-block",
                          value: ticket.broker?.business_name,
                          severity: "info"
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("p", _hoisted_11, [
                        _hoisted_12,
                        _createVNode(_component_Badge, {
                          class: "p-d-block",
                          value: ticket.user?.fullname,
                          severity: "info"
                        }, null, 8, ["value"])
                      ]),
                      (_ctx.isVisible())
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            class: "p-button-info p-ml-2",
                            icon: "pi pi-eye",
                            onClick: _withModifiers(($event: any) => (_ctx.ticketDetails(ticket.id)), ["stop"])
                          }, null, 8, ["onClick"])), [
                            [
                              _directive_tooltip,
                              _ctx.$t('open'),
                              void 0,
                              { bottom: true }
                            ]
                          ])
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("div", {
                      ref: 'status_bar_' + ticket.id,
                      class: "status_bar"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ticket.sliderSteps, (step, index) => {
                        return _withDirectives((_openBlock(), _createElementBlock("div", {
                          key: `tracking_${index}`,
                          style: _normalizeStyle({ left: step.position + 'px' }),
                          onClick: ($event: any) => (_ctx.setSlider(step.status, step.index))
                        }, [
                          _createElementVNode("div", _hoisted_14, [
                            (step.status === 110)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            (step.status === 130)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_17))
                              : _createCommentVNode("", true)
                          ])
                        ], 12, _hoisted_13)), [
                          [
                            _directive_tooltip,
                            _ctx.$t(`ticket.statuses.${_ctx.TicketStatusEnum[step.status]}`),
                            void 0,
                            { top: true }
                          ]
                        ])
                      }), 128))
                    ], 512)
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ticket.sliderSteps, (step, index) => {
                      return (_openBlock(), _createBlock(_component_Button, {
                        onClick: ($event: any) => (_ctx.changeStep(step.index)),
                        class: _normalizeClass(`p-button-sm status_${_ctx.TicketStatusEnum[step.status].toLowerCase()}${step.selected ? ' focused' : ''}`),
                        key: `tracking_${index}`
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            class: _normalizeClass(`pi ${step.status === 110 ? 'pi pi-arrow-up' : 'pi pi-arrow-down'} p-button-icon p-button-icon-left`)
                          }, null, 2),
                          _createElementVNode("span", _hoisted_19, [
                            _createTextVNode(_toDisplayString(_ctx.getStatusLabel(step)) + " ", 1),
                            _createElementVNode("span", _hoisted_20, _toDisplayString(step.time), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["onClick", "class"]))
                    }), 128))
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]))
}